"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "arrone": {
    "28730a88": [{
      "hkey": "79eb67b8",
      "slug": "buonacquisto",
      "name": "Buonacquisto",
      "primary": true,
      "skipSearch": false
    }],
    "bonacquisto": [{
      "hkey": "79eb67b8",
      "slug": "buonacquisto",
      "name": "Buonacquisto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "d4b67ed0": [{
      "hkey": "9ee63d0f",
      "slug": "arrone",
      "name": "Arrone",
      "primary": true,
      "skipSearch": false
    }],
    "colleluccio": [{
      "hkey": "9ee63d0f",
      "slug": "arrone",
      "name": "Arrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "a48b8896": [{
      "hkey": "9ee63d0f",
      "slug": "arrone",
      "name": "Arrone",
      "primary": true,
      "skipSearch": false
    }],
    "tripozzo": [{
      "hkey": "9ee63d0f",
      "slug": "arrone",
      "name": "Arrone",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;